import { DependencyDirection as DtoDependencyDirection, type IndirectRelation, Type } from "~/models/dto";

import type { TopologySnapshot } from "../../../app/state/topology/TopologySnapshot";
import { Api, type FullRelation } from "../../../common/openapi";

import type { IconRelationTypes } from "./StateRelationArrowIcon";
import {
	type SimpleStatefulComponent,
	fullToSimpleStatefulComponent,
	viewToSimpleStatefulComponent,
} from "./state-component-utils";

import DependencyDirection = Api.DependencyDirection;

export interface SimpleRelation {
	_type: IconRelationTypes;
	id: number;
	name?: string;
	dependencyDirection: DependencyDirection;
	source: SimpleStatefulComponent;
	target: SimpleStatefulComponent;
}

export const fullToSimpleRelation = (relation: FullRelation): SimpleRelation => ({
	_type: Type.Relation,
	id: relation.data.id!,
	name: relation.data.name,
	dependencyDirection: relation.data.dependencyDirection,
	source: fullToSimpleStatefulComponent(relation.source),
	target: fullToSimpleStatefulComponent(relation.target),
});

export const convertDependencyDirection = (dir: DtoDependencyDirection) => {
	switch (dir) {
		case DtoDependencyDirection.Both:
			return DependencyDirection.Both;
		case DtoDependencyDirection.OneWay:
			return DependencyDirection.OneWay;
		default:
			return DependencyDirection.None;
	}
};

export const indirectToSimpleRelation = (relation: IndirectRelation, snapshot: TopologySnapshot): SimpleRelation => {
	const source = snapshot.components.get(relation.source)!;
	const target = snapshot.components.get(relation.target)!;

	return {
		_type: relation._type,
		id: relation.id,
		name: `${source.name} - ${target.name}`,
		dependencyDirection: convertDependencyDirection(relation.dependencyDirection),
		source: viewToSimpleStatefulComponent(source, snapshot.componentTypes),
		target: viewToSimpleStatefulComponent(target, snapshot.componentTypes),
	};
};
